import { Component, OnInit, OnDestroy} from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { HelperService } from '@app/core';
import { ActivatedRoute, Params } from "@angular/router";
import { EventSourceService } from './event-source.service';
import { SubscriptionLike } from 'rxjs';
import { environment } from '@app/../environments/environment';
import { stubFalse } from 'lodash';
import { marked } from 'marked';
import { MarkdownService } from './markdown-service';
declare var $: any;
declare var window:any;

@Component({
    selector: 'app-knowledge-base-ai',
    templateUrl: './knowledge-base-ai.component.html',
    standalone: false
})
export class KnowledgeBaseAiComponent implements OnInit , OnDestroy {

    inputContent: string = '';
    isProcessing: Boolean = false;
    questionAnswersList: StartDeckAssistantQuestionAnswer[] = [];
    updatedResponse:string='';
    refactoredGptResponse:string="";
    searchBar: boolean = true;
    knowledgeBaseHeading:string="";
    identifire:string="";
    eventSourceSubscription: SubscriptionLike | null = null;
    currentQuestionAnswer: StartDeckAssistantQuestionAnswer | null = null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private helperService: HelperService,
        private activeRoute: ActivatedRoute,
        private eventSourceService: EventSourceService,
        private markdownService: MarkdownService

    ) {
        this.initScroller()

     }
    ngOnInit(): void {
        this.identifire=this.activeRoute.snapshot.params.identifire
        this.initScroller();

        this.activatedRoute.params.subscribe((params: Params) => {
            this.identifire=this.activatedRoute.snapshot.params.identifire;
            this.getChatgptIdentifierdetails();
            this.getOldResponseFromThread();
        });
    }
    ngOnDestroy() {
        this.eventSourceSubscription?.unsubscribe();
        this.eventSourceService.close();
    }
    addMessageToCurrentQuestionAnswer(text : string, concat : boolean = false){
        if(this.currentQuestionAnswer){
            if(concat){
                let answer =  this.currentQuestionAnswer.answer;
                answer += text;
                this.currentQuestionAnswer.answer = answer;
            }else{
                this.currentQuestionAnswer.answer = text;
            }
        }
    }
    debug(...params){
        console.log(params);
    }
    debugError(...params){
        console.error(params);
    }

    getChatgptIdentifierdetails(){
        if(this.identifire){
            const requestPayload = {
                identifire:this.identifire,
            };
            this.apiService.post('knowledge-base/ai/get-chatgpt-details',requestPayload).subscribe((response:any)=>{
                // Right know only setting the title of the chatgpt identifier
                this.knowledgeBaseHeading = response.chatGptAssistant.title;
            })

        }
    }

    getOldResponseFromThread(){
        let threadId =localStorage.getItem('gpt_assistant_thread_id '+this.identifire)
        if(threadId){
          const requestPayload = {
              threadId: threadId,
              identifire:this.identifire,
          };

          this.isProcessing = true;
          this.apiService.post('knowledge-base/ai/get-thread-old-responses',requestPayload).subscribe((response:any)=>{
                this.isProcessing = false;

                this.questionAnswersList=[];
                var self=this,question="",answer="",flag = 0; //flag is used to identify if role ==user ocuur two time concurrently that means previous question has no answer
                for (let i = 0; i < response.content.length; i++) {
                    let value = response.content[i];

                    if (value.role.trim() === "user") {
                        question = value.content[0].text.value;
                        flag = 1;
                    } else if (value.role.trim() === "assistant") {
                        answer =this.refactorGptResponse(value.content[0].text.value);
                        flag = 0;

                        self.questionAnswersList.push({ question: question, answer: answer, streamingResponse :false });
                    }
                }

                // Check if the  question has no corresponding answer
                if (flag === 1) {
                    self.questionAnswersList.push({ question: question, answer: "not found", streamingResponse:false });
                }
          })
        }else{
          this.questionAnswersList=[];
        }
    }
    handler(event: KeyboardEvent) {
        if (this.inputContent == '') return

        this.isProcessing = true;

        const userQuestion = this.inputContent;

        this.inputContent = '';

        this.questionAnswersList.push(this.currentQuestionAnswer ={
            question: userQuestion,
            answer: `Generating reply...`,
            streamingResponse: false
        });

        var  threadId = localStorage.getItem('gpt_assistant_thread_id '+this.identifire)

        this.apiService.post('knowledge-base/ai/add-message', {
            message: userQuestion,
            threadId: threadId,
            identifire:this.identifire,
        })
        .subscribe((res: any) => {
            if (res.error) {
                if(this.currentQuestionAnswer){
                    this.currentQuestionAnswer.streamingResponse= false;
                }
                this.isProcessing = false;
                this.helperService.errorMessage("Something went wrong. Please try after some time.");
                this.addMessageToCurrentQuestionAnswer(`\n❌ Something went wrong. Please try after some time.\n Error Code: ADD_MESSAGE_ERROR`);
                return
            } else {
                if(res.thread_id){
                    if(!localStorage.getItem('gpt_assistant_thread_id '+this.identifire)){
                       localStorage.setItem('gpt_assistant_thread_id '+this.identifire, res.thread_id);
                    }
                }

                this.streamResponse(res.thread_id);
            }
        });
    }

    streamResponse(threadId){
        const url = environment.apiEndpoint+'knowledge-base/ai/stream-thread-response?identifire=startdeck_appraisal_assistant&thread_id='+threadId;
        const options = { };
        const eventNames = [
            'thread.run.created',
            'thread.run.queued',
            'thread.run.in_progress',
            'thread.run.requires_action',
            'thread.run.completed',
            'thread.run.incomplete',
            'thread.run.failed',
            'thread.run.cancelling',
            'thread.run.cancelled',
            'thread.run.expired',
            'thread.run.step.created',
            'thread.run.step.in_progress',
            'thread.run.step.delta',
            'thread.run.step.failed',
            'thread.run.step.cancelled',
            'thread.run.step.expired',
            'thread.run.step.created',
            'thread.run.step.in_progress',
            'thread.run.step.completed',
            'thread.run.step.created',
            'thread.message.created',
            'thread.message.in_progress',
            'thread.message.delta',
            'thread.message.completed',
            'thread.message.incomplete',
            'done',
            'error'
        ];

       if(this.currentQuestionAnswer){
            this.currentQuestionAnswer.answer="";
            this.currentQuestionAnswer.streamingResponse= true;
       }
       this.eventSourceSubscription = this.eventSourceService.connectToServerSentEvents(url, options, eventNames).subscribe({
                next : async ( {eventName, eventData}) => {
                    this.debug("eventName:", eventName);
                    this.debug("eventData:", eventData);

                    if(eventName == "done"){
                        if(this.currentQuestionAnswer){
                            this.currentQuestionAnswer.streamingResponse= false;
                        }
                        this.isProcessing = false;
                        this.eventSourceSubscription?.unsubscribe();
                        this.eventSourceService.close();
                    }else if ([
                        "error",
                        "thread.run.failed",
                        "thread.run.expired",
                        "thread.run.cancelled",
                        "thread.run.step.failed",
                        "thread.run.step.cancelled",
                        "thread.run.step.expired"
                    ].includes(eventName)) {
                        if(this.currentQuestionAnswer){
                            this.currentQuestionAnswer.streamingResponse= false;
                        }
                        this.isProcessing = false;
                        var eventObj = JSON.parse(eventData);
                        var errorCode = eventObj?.last_error?.code;
                        this.addMessageToCurrentQuestionAnswer(`❌ Something went wrong. Please try after some time.\n Error Code:${errorCode}`);
                        this.eventSourceSubscription?.unsubscribe();
                        this.eventSourceService.close();
                    }else if(eventName == "thread.run.in_progress"){
                        this.addMessageToCurrentQuestionAnswer("");
                    }else if(eventName == "thread.message.delta"){
                        var eventObj = JSON.parse(eventData);
                        this.debug("eventObj:", eventData);
                        let  deltaText = eventObj?.delta?.content[0].text?.value;
                        if(deltaText && deltaText != ""){
                            this.addMessageToCurrentQuestionAnswer(deltaText, true);
                        }
                    }else if(eventName == "thread.message.completed"){
                        const eventObj = JSON.parse(eventData);
                        this.debug("eventObj:", eventData);
                        const  message = eventObj?.content[0].text?.value;
                        if(message && message != ""){
                            const html = await this.markdownService.convertToHtml(message || '');
                            this.addMessageToCurrentQuestionAnswer(html);
                            this.isProcessing = false
                        }
                    }
                },
                error: error => {
                    this.debugError(error);
                    this.isProcessing = false;
                    this.eventSourceSubscription?.unsubscribe();
                    this.eventSourceService.close();
                }
            }
        );
    }

    back() {
        this.helperService.jumpToPreviousPage();
    }
    refactorGptResponse(content){
        let updatedResponse=content.replace(/- (#{1,3})(.*?)\1/g, function(match, level, content) {
            const headerLevel = level.length; // Calculate header level based on the number of #
            return `<h${headerLevel}>${content.trim()}</h${headerLevel}>`;
        });

          updatedResponse = updatedResponse.replace(/- \*\*(.*?)\*\*/g, (match, content) => {
            return `<strong>${content}</strong>`;                                                        // it replace the content between -** TEST ** to bold
        });

        updatedResponse = updatedResponse.replace(/\*\*(.*?)\*\*/g, (match, content) => {
            return `<strong>${content}</strong>`;                                                       // it replace the content between ** TEST ** to bold
        });

        updatedResponse = updatedResponse.replace(/\n\s*(-+)/g, '\n•');     // if it get the dash after \n then it replace with dot
        updatedResponse = updatedResponse.replace(/\[|\]/g, '');          // it remove the  square brackets.
        updatedResponse = updatedResponse.replace(/\((.*?)\)/g, '<a href="$1"> $1</a>');   // it convert the content to link inside ()
        updatedResponse = updatedResponse.replace(/#+(.*?)\\n/g, '<strong>$1</strong>');  // it replace content between # and \n . no matter how man #

        updatedResponse = updatedResponse.replace(/###(.*?):/g, (match, content) => {    //it replace the content to bold between ### and :
             return `<strong>${content.trim()}:</strong>`;
        });

        return updatedResponse;

    }

    initScroller(){
        var self = this;
        $(document).scroll(function () {
            if (self.searchBar) {
              if ($('#bottomFixedStop').offset().top + $('#bottomFixedStop').height() >= $('#bottomFixedStopArea').offset().top - 10)
                $('#bottomFixedStop').css({ 'position': 'absolute', 'transform': 'unset', 'margin': '0 auto' ,'left':'0%','max-width':'100%' });

              if ($(document).scrollTop() + window.innerHeight < $('#bottomFixedStopArea').offset().top) {
                $('#bottomFixedStop').css({ 'position': 'fixed', 'transform': 'translateX(-50%)','left':'50%',    'max-width': '968px' }); // restore when you scroll up
                $('#bottomFixedStopArea').css({ 'height': '7rem' });
              } else {
                $('#bottomFixedStopArea').css({ 'height': '0' });
              }
            }
          });
    }
    clearAllThreads(){
        localStorage.removeItem('gpt_assistant_thread_id '+this.identifire);
        this.questionAnswersList = [];
    }

}

type StartDeckAssistantQuestionAnswer = {
    question: string;
    answer: string,
    streamingResponse:boolean|null
};